// @flow
import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation UploadCSVImportMutation($input: UploadCSVImportInput!) {
    uploadCSVImport(input: $input) {
      csvImport {
        csvImportId
        entityType
        fileName
        status
        headers
        previewRows
        totalRows
        columnMapping
      }
    }
  }
`;

export default ({ variables, uploadables }: Object) =>
  createRelayMutation(mutation, { variables, uploadables });
